import { render, staticRenderFns } from "./DashboardFolderContent.vue?vue&type=template&id=164ae69e&"
import script from "./DashboardFolderContent.vue?vue&type=script&lang=js&"
export * from "./DashboardFolderContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports